<!--
    课程分销数据-购买统计
    功能：购买统计
    说明：旧版本
-->
<template>
  <div v-loading="loading">
    <div class="top-data">
      <p>商品名称：{{ topData.name }}</p>
      <p>商品编码：{{ topData.code }}</p>
      <p>上架时间：{{ topData.publish_time }}</p>
    </div>

    <AppList
      ref="list"
      :list.sync="list"
      :api="api"
      title="">
      <AppSearch
        slot="search"
        :order="{ type: 'id', name: 'desc'}"
        :search-arr="searchArr"/>
      <template slot-scope="props">
        <el-table :data="props.listData">
          <el-table-column
            v-for="column in columns"
            v-if="!column.show"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
          />
          <el-table-column
            label="操作"
            width="300px"
            class="orgin-btn"
          >
            <template slot-scope="scope">
              <el-link
                v-if="$store.state.from === 'schoolCenter'"
                @click="showDetail(scope.row.id)"
              >查看详情</el-link>
              <el-button
                v-else
                class="opt-btn"
                size="small"
                @click="showDetail(scope.row.id)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </AppList>

    <el-dialog
      :visible.sync="dialogDetail.show"
      title="订单详情"
      class="dialog-sp1"
      width="647px">
      <div class="dialog-detail">
        <div class="detail-row">
          <div class="detail-col flex jb">
            <div><span class="gray">商品名称：</span>{{ dialogDetail.data.commodities.name }}</div>
            <!--            <div><span class="gray">商品编号：</span>{{dialogDetail.data.commodities.code}}</div>-->
            <div><span class="gray">订单号：</span>{{ dialogDetail.data.code }}</div>
          </div>
          <div class="detail-col flex jb">
            <div><span class="gray">创建时间：</span>{{ dialogDetail.data.created_at }}</div>
            <div><span class="gray">创建账户：</span>{{ dialogDetail.data.user.mobile }}</div>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-col flex jb">
            <div><span class="gray">线下课时单价（课时/次）：</span>原价：{{ dialogDetail.data.commodities.offline_price }}金币</div>
            <div><span class="gray">优惠价：</span>{{ dialogDetail.data.commodities.offline_discount_price }}金币</div>
          </div>
          <div class="detail-col flex jb">
            <div><span class="gray">线上课时单价（课时/学生/次）：</span>原价：{{ dialogDetail.data.commodities.online_price }}金币</div>
            <div><span class="gray">优惠价：</span>{{ dialogDetail.data.commodities.online_discount_price }}金币</div>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-col flex jb">
            <div><span class="gray">线下课次（课时/次）：</span>{{ dialogDetail.data.offline_num }}次</div>
          </div>
          <div class="detail-col flex jb">
            <div><span class="gray">线上学生课次（课时/学生/次）：</span>{{ dialogDetail.data.online_num }}次</div>
          </div>
        </div>
        <div class="detail-row">
          <!--<div class="detail-col flex jb">
            <div><span class="gray">支付状态：</span>{{dialogDetail.data.status_text}}</div>
            <div v-if="dialogDetail.data.paid_at"><span class="gray">支付时间：</span>{{dialogDetail.data.paid_at}}</div>
          </div>
          <div class="detail-col flex jb">
            <div></div>
            <div><span class="gray">套餐金币抵扣：</span>{{dialogDetail.data.coin_paid}}金币</div>
          </div>-->
          <div class="detail-col flex jb">
            <div/>
            <div><span class="gray">原总价：</span>{{ dialogDetail.data.original_coin }}金币</div>
          </div>
          <div class="detail-col flex jb">
            <div/>
            <div><span class="gray">现金支付：</span>{{ dialogDetail.data.cash_paid }}金币</div>
          </div>
          <div class="detail-col flex jb">
            <div/>
            <div><span class="gray">优惠总价：</span><span class="red">{{ dialogDetail.data.discount_coin }}金币</span></div>
          </div>
        </div>
      </div>
      <div class="detail-foot flex jc">
        <el-button
          type="primary"
          @click="dialogDetail.show = false">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import baseUrl from '../../utils/api';

export default {
  name: 'GoodsBuyStatistics',
  inject: ['reload'],
  data() {
    return {
      loading: false,
      list: {},
      api: `${baseUrl}/api/course/commodities/orders?order[created_at]=desc&in[status][]=2&in[status][]=3&equal[commodities_id]=${this.$route.query.id}`,
      columns: [
        { prop: 'school.review_used.name', label: '购买校区' },
        { prop: 'user.mobile', label: '购买账号' },
        { prop: 'discount_coin', label: '购买金币' },
        { prop: 'code', label: '订单号' },
        { prop: 'created_at', label: '购买时间' },
      ],

      dialogDetail: { // 查看详情
        show: false,
        data: {
          commodities: {
            make_school: {},
          },
          user: {},
        },
      },

      topData: {},
    };
  },
  computed: {
    searchArr() {
      return [
        {
          componentType: 'AppSearchDate',
          searchType: 'created_at',
        },
        {
          componentType: 'AppSearchColumn',
          searchType: 'search_school_name',
          placeholder: '校区名称',
        },
      ];
    },
  },
  created() {
    this.$http.get(`${baseUrl}/api/course/commodities/${this.$route.query.id}`).then((res) => {
      this.topData = res.data;
    });
  },
  methods: {
    // 查看详情
    showDetail(_id) {
      this.loading = true;

      this.$http.get(`${baseUrl}/api/course/commodities/orders/${_id}`).then((res) => {
        this.dialogDetail.data = res.data;
        this.dialogDetail.show = true;
      }).finally(() => {
        this.loading = false;
      });
    },

    searchCall(arr) {
      if (!arr.length) {
        this.reload();
        return;
      }

      this.loading = true;

      this.$http.get(`${baseUrl}/api/course/commodities?${arr.join('&').replace(/\:/g, '=')}`).then((res) => {
        const _arr = [];

        res.items.forEach(val => _arr.push(`in[commodities_id][]=${val.id}`));

        this.$http.get(`${this.api}&${_arr.join('&')}`).then((res) => {
          this.list = res;
        }).finally(() => {
          this.loading = false;
        });
      }).catch(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
  @import '../../assets/reset.scss';

  .dialog-detail {
    .gray {
      color: #909399;
    }
    .red {
      color: #FF5454;
      font-size: 18px;
      font-weight: bold;
    }
  }
  .detail-row {
    padding-bottom: 20px;

    &:not(:first-child) {
      padding-top: 20px;
      border-top: 1px dashed #D8D8D8;
    }
  }
  .detail-col:not(:first-child) {
    margin-top: 12px;
  }
  .detail-foot {
    padding-top: 40px;

    /deep/ .el-button {
      padding: 8px 20px;
    }
  }

  .top-data {
    display: flex;
    justify-content: space-between;
    max-width: 800px;
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// src/views/CourseDistribution/goodsBuyStatistics.vue